"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyQueryDelta = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useApplyQueryDelta(id) {
    const { data, isLoading, error, patch } = (0, core_ui_1.useApiPatch)(`queries/${id}/deltas`);
    return {
        updatedResult: data,
        isUpdating: isLoading,
        updateError: error,
        applyQueryDeltas: patch
    };
}
exports.useApplyQueryDelta = useApplyQueryDelta;
//# sourceMappingURL=useApplyQueryDelta.js.map